// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"85c7678e","453":"20e57884"}[chunkId] + ".chunk.js";
};